import { Injectable } from '@angular/core';

import { ObjectStorage } from 'src/app/utils/object-storage/object-storage';
import { CURRENT_SETTINGS } from 'src/configs/settings/current-settings';
import { Settings } from 'src/configs/settings/settings.interface';

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends ObjectStorage<Settings> {
  public constructor() {
    super();
    this.storedObject = CURRENT_SETTINGS;
  }
}
